import { defineMessages } from 'react-intl';


export default defineMessages({
  // menu items
  menuItemHome: {
    id: 'app.components.RSLeftMenu.menuItemHome',
    defaultMessage: 'Home',
  },
  menuItemPrivacy: {
    id: 'app.components.RSLeftMenu.menuItemPrivacy',
    defaultMessage: 'Privacy Policy',
  },
  menuItemTerms: {
    id: 'app.components.RSLeftMenu.menuItemTerms',
    defaultMessage: 'Terms of Use',
  },
  menuItemHelp: {
    id: 'app.components.RSLeftMenu.menuItemHelp',
    defaultMessage: 'Get Help',
  },
  menuItemRedemptions: {
    id: 'app.components.RSLeftMenu.menuItemRedemptions',
    defaultMessage: 'Redemption History',
  },
  menuItemPoints: {
    id: 'app.components.RSLeftMenu.menuItemPoints',
    defaultMessage: 'Point History',
  },
  menuItemFavorites: {
    id: 'app.components.RSLeftMenu.menuItemFavorites',
    defaultMessage: 'Favorites',
  },
  menuItemLotteries: {
    id: 'app.components.RSLeftMenu.menuItemLotteries',
    defaultMessage: 'Lotteries',
  },
  menuItemRegisterGirls: {
    id: 'app.components.RSLeftMenu.menuItemRegisterGirls',
    defaultMessage: 'Invite your girls',
  },
  // other
  categories: {
    id: 'app.components.RSLeftMenu.categories',
    defaultMessage: 'Categories',
  },
  profiles: {
    id: 'app.components.RSLeftMenu.profiles',
    defaultMessage: 'Profiles',
  },  
  myPoints: {
    id: "app.components.RSLeftMenu.myPoints",
    defaultMessage: "My Points",
  },
});
